import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import FoodDatabase from '../components/FoodDatabase/FoodDatabase';
import { tabContainerStyles, tabStyles, avatarStyles } from '../theme/componentStyles';
import RarityAvatar from '../components/common/RarityAvatar';
import { animalTypes } from '../utils/animalUtils';

// Container styles for consistent layout
// Container styles are now applied directly in the Box component

const Food = () => {
  const { animalType = 'birds' } = useParams();
  const navigate = useNavigate();
  
  const [tabValue, setTabValue] = useState(() => {
    const tabIndex = animalTypes.findIndex(type => type.id === animalType);
    return tabIndex >= 0 ? tabIndex : 0;
  });

  useEffect(() => {
    const tabIndex = animalTypes.findIndex(type => type.id === animalType);
    if (tabIndex >= 0 && tabIndex !== tabValue) {
      setTabValue(tabIndex);
    } else if (tabIndex === -1) {
      // Redirect to default if invalid animal type
      navigate('/food/birds', { replace: true });
    }
  }, [animalType, navigate, tabValue]);

  const handleChange = (event, newValue) => {
    const type = animalTypes[newValue];
    if (type) {
      navigate(`/food/${type.id}`);
    }
  };

  return (
    <Box sx={{ 
      width: '100%',
      minHeight: '100vh',
      pt: 4,
      pb: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'rgba(0, 0, 0, 0.1)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '4px',
      },
    }}>
      <Box sx={{ ...tabContainerStyles.inner, width: 1200, mx: 'auto', px: 0 }}>
        <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: 0 }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ 
              ...tabStyles.container,
              width: '100%',
              '& .MuiTabs-flexContainer': {
                display: 'flex',
                justifyContent: 'space-around',
                width: '100%',
                gap: 2
              },
              '& .MuiTab-root': {
                minWidth: 'auto',
                flex: 1,
                maxWidth: 'none',
                padding: '6px 8px'
              }
            }}
            aria-label="animal type tabs"
          >
            {animalTypes.map((type) => (
              <Tab
                key={type.id}
                label={
                  <Box sx={tabStyles.content}>
                    <RarityAvatar
                      src={type.image}
                      alt={type.name}
                      size="md"
                      sx={avatarStyles.standard}
                      aria-label={`View ${type.name} food`}
                    />
                    <Typography variant="caption" sx={tabStyles.label}>
                      {type.name}
                    </Typography>
                  </Box>
                }
                sx={{ width: '400px', ...tabStyles.root }}
              />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: 0 }}>
          <FoodDatabase animalType={animalType} />
        </Box>
      </Box>
    </Box>
  );
};

export default Food;
